<template>
  <div>
    <div class="form-container">
      <div class="tools">
        <form-button @click="$emit('check')">返回</form-button>
        <form-button @click="confrimCheck">保存</form-button>
      </div>
      <el-form
        ref="form"
        inline
        size="mini"
        label-width="110px"
        :model="conditions"
      >
        <common-title title="基本信息" />

        <el-row :gutter="24">
          <!--el-col :lg="8" :md="12">
            <el-form-item label="结算单号">
              <el-input
                v-model="conditions.settlementNo"
                placeholder="自动生成"
                disabled
              />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="结算日期">
              <el-input
                v-model="conditions.created_date"
                disabled
              />
            </el-form-item>
          </el-col-->
          <el-col :lg="8" :md="12">
            <el-form-item label="结算周期起">
              <el-input
                v-model="conditions.startDay"
                disabled
              />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="结算周期止">
              <el-input
                v-model="conditions.endDay"
                disabled
              />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="发货仓库">
              <el-select v-model="conditions.warehouse" placeholder="" clearable>
                <el-option
                  v-for="item in selectDataOptions['Warehouse']"
                  :key="item.value"
                  :label="item.name"
                  :value="item.value"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="客户编码">
              <wly-input
                v-model="conditions.customerCode"
                input-type="customer"
                clearable
                @enter="handleEnter"
                @handleSuffixClick="showDialog = true"
              />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="客户名称">
              <el-input v-model="conditions.customerName" disabled />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="24">
          <el-col :lg="8" :md="12">
            <el-form-item label="签收日期起">
              <el-input
                v-model="conditions.signStartDate"
                disabled
              />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="签收日期止">
              <el-input
                v-model="conditions.signEndDate"
                disabled
              />
            </el-form-item>
          </el-col>
          <!--el-col :span="8">
            <el-form-item label="备注" prop="comment">
              <el-input v-model="conditions.comment" />
            </el-form-item>
          </el-col-->
        </el-row>
      </el-form>
    </div>

    <div class="table-container">
      <TableCommon title="明细" :custome-config="() => vxeShowCustom('gridOptions')">
        <template #button>
          <table-button name="export" tip="导出" @click="exportExcel" />
        </template>
        <vxe-grid
          ref="gridOptions"
          class="table-block"
          border
          :highlight-hover-row="true"
          resizable
          :show-overflow="true"
          height="240"
          max-height="500"
          align="center"
          size="mini"
          :checkbox-config="{ highlight: true }"
          :radio-config="{ highlight: true }"
          :empty-render="{ name: 'NotData' }"
          :toolbar-config="{ custom: true, size: 'mini' }"
          :row-config="{ isCurrent: true }"
          :edit-config="{ trigger: 'manual', mode: 'row' }"
          :columns="gridOptions.columns"
          :data="gridOptions.data"
          @filter-change="filterChange"
        >
          <template #originalDrawing="{row}">
            <a v-if="row.originalDrawing" class="blue" @click="showImages(row.originalDrawing)">查看</a>
            <span v-else></span>
          </template>
          <template #picture="{row}">
            <a v-if="row.picture" class="blue" @click="showImages(row.picture)">查看</a>
            <span v-else></span>
          </template>
          <template #channelsType="{ row }">
            <span>{{ filterDictionary(row.channelsType, 'A0054') }}</span>
          </template>
        </vxe-grid>
      </TableCommon>
    </div>

    <el-image-viewer
      v-if="showViewer"
      :on-close="()=>{showViewer = false}"
      :url-list="viewers"
    />
    <el-dialog
      v-dialogDrag
      :visible.sync="showDialog"
      title="客户选择"
      width="70%"
    >
      <client-select v-if="showDialog" ref="clientSelect" />
      <div slot="footer">
        <el-button size="small" @click="showDialog = false">取消</el-button>
        <el-button size="small" type="primary" @click="handleSubmit">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { filterDictionary } from '@/utils/index'
import { apiLoadDictionaryDtl } from '@/api/platform/dictionary/index'
import { apiFindDeliverySettlementGeneration, apiAddDeliverySettlementGeneration } from '@/api/applyForGoods/logisticsAbnormal'
import ClientSelect from '@/components/dialog/ClientSelect'
import { frontExport } from '@/utils/frontExport'
import ElImageViewer from 'element-ui/packages/image/src/image-viewer'

export default {
  components: {
    ClientSelect,
    ElImageViewer
  },
  props: {
    params: {
      type: Object,
      default: () => null
    }
  },
  data() {
    return {
      selectDataOptions: {},
      showDialog: false,
      showViewer: false,
      conditions: {
        settlementNo: '',
        comment: '',
        created_by_name: '',
        created_date: '',
        endDay: '',
        startDay: '',
        warehouse: '',
        customerCode: '',
        customerName: ''
      },
      gridOptions: {
        columns: [
          { type: 'checkbox', field: 'checkbox', title: '', width: 40 },
          { title: '发货单号', field: 'wantCode', filters: [], filterMultiple: false, width: 100  },
          { title: '运单号', field: 'logisticno', filters: [], filterMultiple: false, width: 120  },
          { title: '客户名称', field: 'customerName', filters: [], filterMultiple: false, width: 180  },
          { title: '产品名称', field: 'productDesc', filters: [], filterMultiple: false, width: 200  },
          { title: '申请时间', field: 'createdDate', filters: [], filterMultiple: false, width: 140 },
         // { title: '申请数量', field: 'wantQuantity',width: 80, xlsxFmt: { t: 'n' }},
          { title: '发运数量', field: 'actDeliveryQty',width: 70, xlsxFmt: { t: 'n' }},
          { title: '渠道类型', field: 'channelsType',width: 100,slots: { default: 'channelsType' }},
          { title: '仓库', field: 'warehouse', width: 140 },
          { title: '推送安吉时间', field: 'sendTime', width: 140 },
          { title: '安吉回单时间', field: 'receiptDate', width: 140 },
          { title: '应到货时间', field: 'shouldArrivedate', width: 140 },
          { title: '接收24小时是否反馈', field: 'feedback', width: 80 },
          { title: '客户签收时间', field: 'signDate',width: 140},
          { title: '客户签收图片', field: 'originalDrawing',width: 70,slots: { default: 'originalDrawing' }},
          { title: '安吉签收图片', field: 'picture',width: 70,slots: { default: 'picture' }},
          { title: '签收推送时间', field: 'signSendTime',width: 140},
          { title: '备注', field: 'remark',width: 250 }
        ],
        data: []
      }
    }
  },
  watch: {
    'conditions.customerName': {
      handler() {
        this.init()
      }
    },
    'conditions.warehouse': {
      handler() {
        this.init()
      }
    }
  },
  activated() {
    this.init()
  },
  created() {
    this.conditions.endDay = this.params.endDate
    this.conditions.startDay = this.params.startDate
    this.conditions.customerCode = this.params.customerCode
    this.conditions.customerName = this.params.customerName
    this.conditions.warehouse = this.params.warehouse
    this.conditions.endDay = this.params.endDate
    this.conditions.signStartDate = this.params.signStartDate
    this.conditions.signEndDate = this.params.signEndDate
    this.getSelectDictDataOrigin('Warehouse')
  },
  mounted() {
    this.init()
  },
  methods: {
    filterDictionary,
    exportExcel() {
      const data = this.gridOptions.data.map(item => {
        const channelsType = this.filterDictionary(item.channelsType, 'A0054')
        return {
          ...item,
          channelsType
        }
      })
      frontExport(this.gridOptions.columns, data, '发货运费结算明细')
    },
    async init() {
      // 渠道类型
      this.getSelectDictDataOrigin('A0054')
      const { data } = await apiFindDeliverySettlementGeneration(this.conditions)
      this.setColumnsFilters(data)
      this.gridOptions.data = data
    },
    confrimCheck() {
      const checkData = this.$refs.gridOptions.getCheckboxRecords()
        if (checkData == 0){
         this.$message.error('请选择要结算的要货明细！')
        }
      if (!checkData.length) {
        return this.$message.warning('请选择要结算的要货明细！')
      }

      this.$confirm('是否真的要进行运费结算处理?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async res => {
        const params = {
          ...this.conditions,
          list:checkData,
          dtoList: this.gridOptions.data
        }
        const result = await apiAddDeliverySettlementGeneration(params)

        if (result.status === 1) {
          this.$message.success('操作成功！')
          this.$router.replace('/wly/to-goods/data-searching/delivery-fee-search')
        }
      })
    },
    // 控件回车
    async handleEnter(e, type, data) {
      if (typeof type === 'object') {
        this.errorList ? (this.errorList = [type.message]) : this.$message.error(type.message)
        return
      }
      if (!data) return

      this.conditions.customerCode = data.partner
      this.conditions.customerName = data.name_org1
    },
    showImages(pic) {
      this.showViewer = true
      this.viewers = pic.split(',')
    },
    async handleSubmit() {
      const data = await this.$refs.clientSelect.submitForm()
      if (!data) return

      this.conditions.customerCode = data.partner
      this.conditions.customerName = data.name_org1
      this.showDialog = false
    },
    getSelectDictDataOrigin(dictcode) {
      const formData = new FormData()
      formData.append('code', dictcode)
      apiLoadDictionaryDtl(formData)
        .then(response => {
          this.$set(this['selectDataOptions'], dictcode, response.data.Rows)
        })
        .catch(() => {})
    },
    filterChange({ filters }) {
      const { tableData } = this.$refs.gridOptions.getTableData()

      // 需要重新设置其他未选中的过滤数据
      this.setColumnsFilters(tableData, (xTable, field, data) => {
        const ftInfo = filters.find(item => item.property === field)

        const column = xTable.getColumnByField(field)
        const data2 = data.map(item => {
          return {
            label: item,
            value: item,
            checked: item === ftInfo?.values[0]
          }
        })
        xTable.setFilter(column, data2)
        xTable.updateData()
      })
    },
    /**
     * 设置表格过滤
     * @params {object} data 表格数据
     */
    setColumnsFilters(data) {
      const xTable = this.$refs.gridOptions
      const filterFields = ['wantCode', 'customerName', 'productDesc', 'wantDate']
      filterFields.forEach(field => {
        const filterData = Array.from(new Set(data.map(item => item[field])))
        this.setFilters(xTable, field, filterData)
      })
    },
    /**
     * 设置过滤列
     * @params {object} xTable 表格refs
     * @params {string} field 需要设置过滤的表格字段
     * @params {array} data 过滤列的数据
     */
    setFilters(xTable, field, data) {
      const column = xTable.getColumnByField(field)
      const data2 = data.map(item => {
        return {
          label: item,
          value: item
        }
      })
      xTable.setFilter(column, data2)
      // 修改条件之后，需要手动调用 updateData 处理表格数据
      // xTable.updateData()
    }
  }
}
</script>

<style>
  .blue {
    color: rgb(45, 146, 214);
    cursor: pointer;
  }
</style>



// WEBPACK FOOTER //
// src/views/apply-for-manage/business-processing/components/DeliveryFeeStep2.vue